import { useState } from "react";
import axios from "axios";
import { Button } from "@material-ui/core";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { LINK } from "../../../../../../../config/config";
import { ILegScanProps } from "../../../../../../../@types/components/legScanDetailsprops.types";

// Downloads the on-demand "Foot Health Report" PDF built by the backend
// (GET /scans/foot-health-report?scan_object_id=...&download=1 streams the PDF inline).
const HealthReportButton = ({ legScan }: ILegScanProps) => {
	const [loading, setLoading] = useState(false);

	const downloadReport = async () => {
		if (!legScan._id || loading) return;
		setLoading(true);
		try {
			const token = localStorage.getItem("@jwt");
			const response = await axios.get(`${LINK}/scans/foot-health-report`, {
				params: { scan_object_id: legScan._id, download: 1 },
				responseType: "blob",
				headers: token ? { Authorization: `Bearer ${token}` } : {}
			});

			const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
			const anchor = document.createElement("a");
			anchor.href = blobUrl;
			anchor.download = `foot-health-report-${legScan.customer_scan_id || legScan._id}.pdf`;
			document.body.appendChild(anchor);
			anchor.click();
			anchor.remove();
			window.URL.revokeObjectURL(blobUrl);
		} catch (error) {
			console.log("Failed to download foot health report", error);
			alert("Could not generate the foot health report. Please try again.");
		} finally {
			setLoading(false);
		}
	};

	return (
		<Button
			variant="contained"
			startIcon={<PictureAsPdfIcon />}
			onClick={downloadReport}
			disabled={loading}
			style={{ backgroundColor: "#25a18e", color: "#fff", textTransform: "none", fontWeight: 600 }}
		>
			{loading ? "Generating…" : "Download Health Report"}
		</Button>
	);
};

export default HealthReportButton;
